/** Navigation interne module Shotokan Black Dragon — BT-020 */

export const SHOTOKAN_MODULE_FR = "Shotokan Black Dragon";
export const SHOTOKAN_MODULE_EN = "Shotokan Black Dragon";

export const ADMIN_SHOTOKAN_BASE = "/admin/shotokan-black-dragon";
export const SENSEI_SHOTOKAN_BASE = "/sensei/shotokan-black-dragon";
export const SEMPAI_SHOTOKAN_BASE = "/sempai/shotokan-black-dragon";

/** Anciennes routes admin — retirées du menu principal, conservées en redirection */
export const LEGACY_ADMIN_SHOTOKAN_PATHS = [
  "/admin/titres",
  "/admin/demandes-titres",
  "/admin/reconnaissances",
  "/admin/autorite-titres",
  "/admin/documents-autorite",
  "/admin/dossiers-preuves",
  "/admin/journal-validation",
];

export const LEGACY_SENSEI_SHOTOKAN_PATHS = [
  "/sensei/titres",
  "/sensei/demandes-titres",
  "/sensei/documents-titres",
];

export const LEGACY_SEMPAI_SHOTOKAN_PATHS = ["/sempai/titres", "/sempai/documents-titres"];

export const ADMIN_SHOTOKAN_SUB_NAV = [
  { segment: "", labelFr: "Vue d'ensemble", labelEn: "Overview", testId: "sbd-nav-overview" },
  { segment: "titres", labelFr: "Titres", labelEn: "Titles", testId: "sbd-nav-titres" },
  { segment: "demandes", labelFr: "Demandes de titres", labelEn: "Title requests", testId: "sbd-nav-demandes" },
  { segment: "reconnaissances", labelFr: "Reconnaissances", labelEn: "Recognitions", testId: "sbd-nav-reconnaissances" },
  { segment: "autorite", labelFr: "Autorité", labelEn: "Authority", testId: "sbd-nav-autorite" },
  {
    segment: "documents-preuves",
    labelFr: "Documents & Preuves",
    labelEn: "Documents & Evidence",
    testId: "sbd-nav-documents-preuves",
  },
];

export const SENSEI_SHOTOKAN_SUB_NAV = [
  { segment: "", labelFr: "Vue d'ensemble", labelEn: "Overview", testId: "sbd-sensei-nav-overview" },
  { segment: "titres", labelFr: "Titres", labelEn: "Titles", testId: "sbd-sensei-nav-titres" },
  { segment: "demandes", labelFr: "Mes demandes", labelEn: "My requests", testId: "sbd-sensei-nav-demandes" },
  { segment: "documents", labelFr: "Documents requis", labelEn: "Required documents", testId: "sbd-sensei-nav-documents" },
];

export const SEMPAI_SHOTOKAN_SUB_NAV = [
  { segment: "", labelFr: "Vue d'ensemble", labelEn: "Overview", testId: "sbd-sempai-nav-overview" },
  { segment: "parcours", labelFr: "Parcours titres", labelEn: "Title path", testId: "sbd-sempai-nav-parcours" },
  { segment: "documents", labelFr: "Documents requis", labelEn: "Required documents", testId: "sbd-sempai-nav-documents" },
];
